<button class="ac-notifications" (click)="onOpen()">
  <ac-icon
    name="bell"
    size="general"
    [matBadge]="unreadCountSig() ? unreadCountSig() : null"
    matBadgeColor="primary"
    matBadgeSize="small"
  />
</button>

<ac-notifications-drawer [show]="showDrawer()" (closed)="onClose()" />
